// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import orangeCheck from '../assets/orange-check.svg';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import lightOrangeCheck from '../assets/light-orange-check.svg';
import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

const defaults: Record<string, ThemeUIStyleObject> = {
    'input-default': {
        fontSize: (theme: CarrotTheme) => theme.fontSizes.medium,
        fontFamily: (theme: CarrotTheme) => theme.fonts.gotham,
        width: '100%',
        padding: '14px 0 14px 14px',
        borderRadius: '6px',
        borderColor: (theme: CarrotTheme) => theme.colors.gray,
        borderStyle: 'solid',
        borderWidth: '2px',
        lineHeight: '1.5',
        backgroundColor: (theme: CarrotTheme) => theme.colors.white,
        color: (theme: CarrotTheme) => theme.colors.black80,
        '::placeholder': {
            color: (theme: CarrotTheme) => theme.colors.black40,
        },
        ':hover': {
            borderColor: (theme: CarrotTheme) => theme.colors.carrotOrange,
        },
        ':focus': {
            borderColor: (theme: CarrotTheme) => theme.colors.carrotOrange,
            borderStyle: 'solid',
            borderWidth: '2px',
            outline: 'none',
        },
        ':disabled': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.lightGrey,
            color: (theme: CarrotTheme) => theme.colors.gray,
            ':hover': {
                borderColor: (theme: CarrotTheme) => theme.colors.gray,
            },
            ':focus': {
                borderColor: (theme: CarrotTheme) => theme.colors.lightGrey,
                borderStyle: 'solid',
                borderWidth: '2px',
                outline: 'none',
            },
            cursor: 'not-allowed',
        },
    },
};

const inputThemes: Record<string, ThemeUIStyleObject> = {
    input: {
        variant: 'forms.input-default',
        '> input': {
            fontSize: (theme: CarrotTheme) => theme.fontSizes.medium,
            fontFamily: (theme: CarrotTheme) => theme.fonts.gotham,
            width: '100%',
            border: 'none',
            lineHeight: '1.5',
            outline: 'none',
            ':disabled': {
                cursor: 'not-allowed',
                backgroundColor: 'inherit',
            },
        },
    },
    'input-error': {
        variant: 'forms.input',
        borderWidth: `2px`,
        borderStyle: 'solid',
        borderColor: (theme: CarrotTheme) => theme.colors.errorRed,
    },
    'input-disabled': {
        variant: 'forms.input',

        backgroundColor: (theme: CarrotTheme) => theme.colors.lightGrey,
        color: (theme: CarrotTheme) => theme.colors.gray,
        ':hover': {
            borderColor: (theme: CarrotTheme) => theme.colors.gray,
        },
        ':focus': {
            borderColor: (theme: CarrotTheme) => theme.colors.lightGrey,
            borderStyle: 'solid',
            borderWidth: '2px',
            outline: 'none',
        },
        cursor: 'not-allowed',
    },
};

const labelThemes: Record<string, ThemeUIStyleObject> = {
    label: {
        fontStyle: 'normal',
        textAlign: 'left',
        color: (theme: CarrotTheme) => theme.colors.black,
    },
    'label-header': {
        marginBottom: (theme: CarrotTheme) => theme.space.tiny,
        display: 'block',
        textTransform: 'uppercase',
        letterSpacing: '0.07em',
        fontSize: '13px',
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.bold,
    },
    'label-default': {
        variant: 'forms.label',
    },
    'label-error': {
        variant: 'forms.label',
        color: (theme: CarrotTheme) => theme.colors.errorRed,
    },
    'label-header-default': {
        variant: 'forms.label-header',
    },
    'label-header-error': {
        variant: 'forms.label-header',
        color: (theme: CarrotTheme) => theme.colors.errorRed,
    },
    'label-header-default-required': {
        variant: 'forms.label-header-default',
        '&::after': {
            content: '"*"',
            color: (theme: CarrotTheme) => theme.colors.darkCarrotOrange,
        },
    },
    'label-header-error-required': {
        variant: 'forms.label-header-error',
        '&::after': {
            content: '"*"',
            color: (theme: CarrotTheme) => theme.colors.errorRed,
        },
    },
};

const textareaThemes = {
    textarea: {
        variant: 'forms.input-default',
    },
    'textarea-error': {
        variant: 'forms.input-error',
    },
};

const switchThemes: Record<string, ThemeUIStyleObject> = {
    switch: {
        'input:checked ~ &': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.primary,
            height: '32px',
            width: '46px',
            ':hover': {
                backgroundColor: (theme: CarrotTheme) => theme.colors.lightCarrotOrange,
            },
        },
        'input:checked ~ & > div': {
            backgroundImage: `url(${orangeCheck})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            height: '24px',
            width: '24px',
            transform: 'translateX(60%)',
        },
        'input:checked:hover ~ & > div': {
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${lightOrangeCheck})`,
        },
        'input:checked:hover ~ &': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.lightCarrotOrange,
        },
        'input:hover ~ &': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.lightCarrotOrange,
        },
        'input:focus-visible ~ &': {
            outline: '5px auto -webkit-focus-ring-color',
        },
        'input:disabled ~ &': {
            padding: '2px',
            borderColor: (theme: CarrotTheme) => theme.colors.gray,
            borderWidth: '2px',
            borderStyle: 'solid',
            backgroundColor: (theme: CarrotTheme) => theme.colors.white,
            color: 'gray',
            cursor: 'not-allowed',
        },
        'input:disabled ~ & > div': {
            borderColor: (theme: CarrotTheme) => theme.colors.gray,
            borderWidth: '2px',
            borderStyle: 'solid',
            backgroundColor: (theme: CarrotTheme) => theme.colors.white,
            color: (theme: CarrotTheme) => theme.colors.gray,
            cursor: 'not-allowed',
        },

        '&': {
            backgroundColor: (theme: CarrotTheme) => theme.colors.gray,
            height: '32px',
            width: '46px',
            padding: '4px',
        },
        '& > div': {
            height: '24px',
            width: '24px',
        },
    },
};

const checkboxThemes: Record<string, ThemeUIStyleObject> = {
    checkbox: {
        variant: 'forms.input-default',
        padding: 0,
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '24px',
        width: '24px',
        minHeight: '24px',
        minWidth: '24px',
        marginRight: '10px',
        lineHeight: '1.5',
        cursor: 'pointer',
        alignSelf: 'flex-start',
    },
    'checkbox-focus': {
        variant: 'forms.checkbox',
        borderColor: (theme: CarrotTheme) => theme.colors.darkCarrotOrange,
    },
    'checkbox-error': {
        variant: 'forms.checkbox',
        borderColor: (theme: CarrotTheme) => theme.colors.errorRed,
    },
    'checkbox-error-focus': {
        variant: 'forms.checkbox-error',
        borderColor: (theme: CarrotTheme) => theme.colors.darkCarrotOrange,
    },
    'checkbox-selected': {
        variant: 'forms.checkbox',
        borderColor: (theme: CarrotTheme) => theme.colors.carrotOrange,
        backgroundColor: (theme: CarrotTheme) => theme.colors.carrotOrange,
        ':hover': {
            borderColor: (theme: CarrotTheme) => theme.colors.darkCarrotOrange,
            backgroundColor: (theme: CarrotTheme) => theme.colors.darkCarrotOrange,
        },
    },
    'checkbox-selected-focus': {
        variant: 'forms.checkbox-selected',
        borderColor: (theme: CarrotTheme) => theme.colors.darkCarrotOrange,
        backgroundColor: (theme: CarrotTheme) => theme.colors.darkCarrotOrange,
    },
    'checkbox-disabled': {
        variant: 'forms.checkbox',
        backgroundColor: (theme: CarrotTheme) => theme.colors.lightGrey,
        color: (theme: CarrotTheme) => theme.colors.gray,
        ':hover': {
            borderColor: (theme: CarrotTheme) => theme.colors.gray,
        },
        ':focus': {
            borderColor: (theme: CarrotTheme) => theme.colors.lightGrey,
            borderStyle: 'solid',
            borderWidth: '2px',
            outline: 'none',
        },
        cursor: 'not-allowed',
    },
    'checkbox-selected-disabled': {
        variant: 'forms.checkbox-disabled',
        backgroundColor: (theme: CarrotTheme) => theme.colors.gray,
    },
    'checkbox-label': {
        color: (theme: CarrotTheme) => theme.colors.black80,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        fontSize: (theme: CarrotTheme) => theme.fontSizes.medium,
        lineHeight: '1.5',
    },
    'checkbox-label-error': {
        variant: 'forms.checkbox-label',
        color: (theme: CarrotTheme) => theme.colors.errorRed,
    },
    'checkbox-label-selected': {
        variant: 'forms.checkbox-label',
    },
    'checkbox-label-selected-focus': {
        variant: 'forms.checkbox-label',
    },
    'checkbox-label-focus': {
        variant: 'forms.checkbox-label',
    },
    'checkbox-label-error-focus': {
        variant: 'forms.checkbox-label-error',
    },
    'checkbox-label-disabled': {
        variant: 'forms.checkbox-label',
        color: (theme: CarrotTheme) => theme.colors.gray,
        cursor: 'not-allowed',
    },
    'checkbox-label-selected-disabled': {
        variant: 'forms.checkbox-label-disabled',
    },
};

const forms: Record<string, ThemeUIStyleObject> = {
    ...defaults,
    ...textareaThemes,
    ...labelThemes,
    ...inputThemes,
    ...switchThemes,
    ...checkboxThemes,
};
export default forms;
